import React, { useEffect, useContext, useRef } from 'react';
import ResultRow from './ResultRow';
import ResultHeader from './ResultHeader';
import appContext from '../AppContext';
import { getResultOrderDesc, getFilterValues } from '../services/WranglingService';
import { PropagateLoader } from 'react-spinners';
import { useTranslation } from "react-i18next";

// https://mui.com/material-ui/react-tooltip/
function Result() {
  const results = useRef(null);
  const { t } = useTranslation();
  const { schools, offeringSorts, loadingData, searchedPlace, selectedSchool, locale, gradeFilters, wardFilters } = useContext(appContext);
  let itemRefs = {};

  useEffect(() => {
    results.current.scroll({
      top: 0,
      behavior: 'smooth'
    });
  }, [schools]);

  useEffect(() => {
    if (selectedSchool !== "") {
      let topPos = itemRefs[selectedSchool].offsetTop - results.current.offsetTop;
      results.current.scroll({
        top: topPos,
        behavior: 'smooth'
      });
    }
  // eslint-disable-next-line
  }, [selectedSchool]);

  const createFilterPrintText = () => {
    return {__html: getFilterValues(t, gradeFilters, wardFilters, offeringSorts, searchedPlace) };
  }

  return (
    <div className='flex-grow flex flex-col'>
      <div className='text-[12px] text-my-emerald text-center w-full py-[10px] bg-[#f3f3f3] border-b-[1px] border-b-my-emerald min-h-[39px]'>
        {loadingData? "": getResultOrderDesc(schools, offeringSorts, searchedPlace, locale)}
        <div className='hidden print:block' dangerouslySetInnerHTML={ createFilterPrintText() }></div>
      </div>
      <ResultHeader />
      <div ref={results} className='bg-white overflow-y-auto flex-grow print:overflow-visible max-h-[500px] md:max-h-[955px]'>
        {
          ((schools.length > 0 ) && !loadingData) &&
            <>{
              schools.map((item, i) => {
                  return (
                    <div key={"schoolID_" + item.properties.id} ref={el => (itemRefs[item.properties.id] = el)}>
                      <ResultRow data={item} searchedAddress={searchedPlace} />
                    </div>
                  );
                })
            }</>
        }
        {
          (schools.length === 0 && !loadingData) &&
            <span className='flex justify-center mt-14'>{ t('result.nodata') }</span>
        }
        {
          loadingData &&
            <span className='flex justify-center mt-2 mb-8 md:mt-14'><PropagateLoader color="#36d7b7" /></span>
        }
      </div>
    </div>
  );

}


Result.propTypes = {};

Result.defaultProps = {};

export default Result;
